<template>
  <div class="hello">
    <div class="title1">绑定手机号</div>
    <div class="title2">绑定后，钉钉可以接收设备报警推送</div>
    <div class="input-form">
      <div class="input-container">
        <img src="../../../static/wechat/iconPhone.png" />
        <input
          placeholder="请输入手机号"
          v-model="request.phone"
          maxlength="11"
        />
      </div>
      <div class="input-container">
        <img src="../../../static/wechat/iconCode.png" />
        <input
          placeholder="请输入验证码"
          v-model="request.code"
          maxlength="6"
        />
        <button class="btn-code" @click="getCode">{{ count }}</button>
      </div>
      <div class="input-container">
        <div>选择平台</div>
        <el-select v-model="request.platformId" placeholder="平台选择">
          <el-option
            v-for="item in getUserPlatformlist"
            :key="item.siteid"
            :label="item.sitename"
            :value="item.siteid"
          >
          </el-option>
        </el-select>
      </div>
      <button class="btn-submit" @click="bindWeChat">立即绑定</button>
    </div>
    <div class="wechat-overlay" v-show="isShow">
      <div class="wechat-dialog">
        <div class="wechat-dialog-close" @click="isShow = false"></div>
        <div class="wechat-dialog-content">
          <div class="title2" v-if="datacode == 200">
            确认将微信绑定以下账号？
          </div>
          <div class="title2" v-if="datacode == 202">
            您输入的手机号{{ request.phone }}<br />已绑定其他微信
          </div>
          <div class="wechat-user-logo">
            <img :src="user.userlogo" />
          </div>
          <div class="title2">{{ user.username }}</div>
        </div>
        <div class="wechat-dialog-footer">
          <button v-if="datacode == 200" @click="sureBind">确认绑定</button>
          <button v-if="datacode == 202" @click="isShow = false">取消</button>
          <button v-if="datacode == 202" class="btn-gray" @click="sureBind">
            替换绑定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const TIME_COUNT = 60;
import * as dd from "dingtalk-jsapi";
import { Toast, MessageBox } from "mint-ui";
export default {
  name: "bindPhone",
  data() {
    return {
      count: "获取验证码",
      timer: null,
      isShow: false,
      datacode: 0, //200：账号可以绑定，202：账号已经被其他微信绑定
      request: {
        phone: "",
        code: "",
        platformId: "",
        forwardType: "",
      },
      bindRequest: {
        openId: "",
        phone: "",
      },
      user: {},
      codedata: "",
      userCode: "",
      resdata: "",
      getUserPlatformlist: [],
    };
  },
  mounted() {
    this.bindRequest.openId = this.$route.query.openId;

    this.request.ddAgentId = this.$route.query.ddAgentId;
    this.request.ddCorpId = this.$route.query.ddCorpId;
    this.request.forwardType = this.$route.query.forwardType;
  },
  methods: {
    getCode() {
      var re = new RegExp(/^1\d{10}$/); //当使用构造函数创造正则对象时，需要常规的字符转义规则（在前面加反斜杠 \）
      if (!this.request.phone.match(re)) {
        Toast("请输入11位的手机号码");
        return false;
      }
      this.getUserPlatform();
      var _t = this;
      _t.common.doAction(
        _t.common.smsCode,
        {
          mobile: _t.request.phone,
          platformId: 1,
          userWay: "ddbind",
        },
        function (res) {
          if (res.code != 200) {
            MessageBox.alert(res.msg, "ERROR");
          }
          if (!_t.timer) {
            _t.count = TIME_COUNT;
            _t.show = false;
            _t.timer = setInterval(() => {
              if (_t.count > 0 && _t.count <= TIME_COUNT) {
                _t.count--;
              } else {
                _t.count = "获取验证码";
                clearInterval(_t.timer);
                _t.timer = null;
              }
            }, 1000);
          }
        },
        "weixin"
      );
    },
    getUserPlatform() {
      var _t = this;
      _t.common.doActionGet(
        _t.common.getUserPlatform,
        {
          phone: _t.request.phone,
        },
        function (res) {
          if ((res.code = 200)) {
            console.log(res);
            _t.getUserPlatformlist = res.data;
          }
        },
        "dd"
      );
    },
    bindWeChat() {
      if (this.request.phone == "") {
        Toast("请输入手机号");
        return;
      }
      if (this.request.code == "") {
        Toast("请输入验证码");
        return;
      }

      this.bindBefore();
      //调用接口查询要绑定的用户信息
    },

    bindBefore() {
      var _t = this;
      console.log(_t.common.ddbindLny);
      _t.common.doActionGet(
        _t.common.ddbindBefore,
        {
          phone: _t.request.phone,
          code: _t.request.code,
          platformId: _t.request.platformId,
        },
        function (res) {
          if (res.code == 200 || res.code == 202) {
            _t.ddcode();
            if (res.code == 202) {
              _t.user.username = res.data.nickname;
              _t.user.userlogo = res.data.headImgUrl;
            } else {
              _t.user.username = res.data.username;
              _t.user.userlogo = res.data.userlogo;
            }
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "dd"
      );
    },
    ddcode() {
      if (dd.env.platform !== "notInDingTalk") {
        this.userCode += "开始执行ready ";
        //进行钉钉登录操作
        dd.ready(() => {
          this.userCode = "进入了钉钉 ";
          dd.runtime.permission.requestAuthCode({
            corpId: this.request.ddCorpId, // 企业id
            onSuccess: (info) => {
              //todo: 测试获取授权码
              // this.userCode += " 获取授权码成功 ";
              this.userCode += info.code;
              // 通过该免登授权码可以获取用户身份
              this.getUserInfo(info.code);
              console.log(123456789);
            },
            onFail: (error) => {
              this.userCode += " 获取授权码失败 ";
              console.log("好吧，问题不小");
              this.$Message.error(JSON.stringify(error));
            },
          });
        });
      }
    },
    //调用接口查询要绑定的用户信息
    getUserInfo(data) {
      console.log(123123);
      var _t = this;
      _t.request.ddcode = data;
      console.log(_t.request.ddcode);
      console.log(_t.common.ddbindLny);
      _t.codedata = _t.request;
      _t.common.doActionGet(
        _t.common.ddbindLny,
        _t.request,
        function (res) {
          _t.resdata = res;
          if (res.code == 200 || res.code == 202) {
            _t.datacode = res.code;
            _t.$router.push({
              path: "/ddbindDetail",
              query: { forwardType: _t.forwardType },
            });

            if (res.code == 202) {
              _t.user.username = res.data.nickname;
              _t.user.userlogo = res.data.headImgUrl;
            } else {
              _t.user.username = res.data.username;
              _t.user.userlogo = res.data.userlogo;
            }
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "dd"
      );
    },
    sureBind() {
      var _t = this;
      this.bindRequest.phone = this.request.phone;
      this.bindRequest.platformId = this.request.platformId
      this.common.doActionGet(
        this.common.bindLny,
        this.bindRequest,
        function (res) {
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            var query = {
              openId: _t.bindRequest.openId,
            };
            _t.$router.push({
              path: "/ddbindDetail",
              query: query,
            });
          } else {
            MessageBox.alert("ERROR", res.msg);
          }
        }
      );
    },
  },
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding: 0px 20px;
}
.title1 {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-top: 60px;
}
.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-top: 10px;
}
.input-form {
  margin-top: 70px;
  height: 120px;
}
.input-container {
  height: 24px;
  padding-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  align-items: center;
}
.input-container img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.input-container input {
  border: none;
  flex-grow: 1;
  height: 24px;
  line-height: 24px;
  min-width: 100px;
  font-size: 14px;
}
.btn-code {
  /* width: 100px; */
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
  flex: 0 0 80px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/dd/ddbindPhone.vue